import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./Components/Home";
import PrivacyPage from "./Components/PrivacyPage";

function App() {
	return (
		<div>
			<Navbar />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/privacy" element={<PrivacyPage />} />
			</Routes>
			<Footer />
		</div>
	);
}

export default App;
